import React, { memo } from "react";
import { Box, IconButton } from "@mui/material";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import {
  StyledTextField,
  StyledInputAdornment,
  StyledInputLabel,
} from "./StyledTextFeild";
/**
 * Reuseable Button component
 * @param {*} param0
 * @returns
 */

const TextField = React.forwardRef(({
  id,
  label,
  placeholder,
  type,
  show,
  isShow,
  value,
  onChange,
  onClick,
  onFocus,
  helperText,
  error,
  onBlur,
  height,
  InputProps,
  width,
  marginTop,
  onKeyPress,
  iconclick,
  disabled,
  multiline = false,
  maxRows = 0,
  required = false,
  minRows = 0,
  parentStyle = {},
}, ref) => {
  return (
    <Box sx={{...parentStyle}}>
      <StyledInputLabel>
        {label}
        {required && <span className="required"> * </span>}
      </StyledInputLabel>
      <StyledTextField
        id={id}
        multiline={multiline}
        maxRows={maxRows}
        minRows={minRows}
        disabled={disabled}
        placeholder={placeholder}
        type={show ? "text" : type}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onClick={onClick}
        onBlur={onBlur}
        width={width}
        error={error ? true : false}
        helperText={error ? helperText : null}
        height={height}
        margintop={marginTop}
        onKeyPress={onKeyPress}
        isIcon={!!InputProps}
        ref={ref}
        onWheel={(e) => type === "number" && e.target.blur()}
        onKeyDown={(e) => {
          if (type === "number" && (e.key === "." || e.key === "e")) {
            e.preventDefault();
          }
        }}
        InputProps={{
          endAdornment: (
            <StyledInputAdornment position="end">
              {type === "password" ? (
                <>
                  <IconButton
                    onClick={() => isShow(!show)}
                    edge="end"
                    disabled={disabled}
                  >
                    {show ? (
                      <VisibilityOutlined className="visible-icon" />
                    ) : (
                      <VisibilityOffOutlined className="visible-icon" />
                    )}
                  </IconButton>
                </>
              ) : type === "actionInput" ? (
                <IconButton
                  onClick={iconclick}
                  edge="end"
                  disabled={disabled}
                  type="submit"
                >
                  {InputProps}
                </IconButton>
              ) : (
                InputProps
              )}
            </StyledInputAdornment>
          ),
        }}
      />
    </Box>
  );
});

export default memo(TextField);
